//translate strings
export const translateFunc = key => {
    if (window.selectedLang) {
      if (window.selectedLang[key]) {
        return window.selectedLang[key];
      } else if (window.ukLang[key]) {
        return window.ukLang[key];
      } else {
        return key;
      }
    }
    return key;
  };